<div class="mat-dialog-container mt-2" appDraggable>
    <div class="header">
        <strong> {{'BUTTONS.NEW_RECORD' | translate}}</strong>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)=" closeDialog()"></button>
    </div>

    <div>
        <div class="overflow-box" style="max-height: 500px; overflow: auto;">

            <div class="d-flex flex-column ">
                <div class="d-flex   cursor-pointer ps-4">
                    <div class="ps-4 flex-grow-1" (click)="sortTable('filename')">
                        <strong>{{'FORM.FILE_NAME' | translate}}</strong>
                        <svg-icon [src]="sortOrder ? './icon/chevron-up.svg' : './icon/chevron-down.svg'" [svgStyle]="{
                            width: '16px',
                            height: '16px'            
                          }"></svg-icon>

                    </div>
                    <div class="ps-4 flex-grow-1" (click)="sortTable('date')">
                        <strong>{{'FORM.DATE_AND_TIME' | translate}}</strong>
                        <svg-icon [src]="sortOrder ? './icon/chevron-up.svg' : './icon/chevron-down.svg'" [svgStyle]="{
                            width: '16px',
                            height: '16px'            
                          }"></svg-icon>
                    </div>
                    <div class="ps-4 flex-grow-1" (click)="sortTable('note')">
                        <strong>{{'VIBRATION.NOTE' | translate}}</strong>
                        <svg-icon [src]="sortOrder ? './icon/chevron-up.svg' : './icon/chevron-down.svg'" [svgStyle]="{
                            width: '16px',
                            height: '16px'            
                          }"></svg-icon>
                    </div>

                    <div class="ps-4 flex-grow-1" (click)="sortTable('Maximum')">
                        <strong>{{'VIBRATION.MAX' | translate}}</strong>
                        <svg-icon [src]="sortOrder ? './icon/chevron-up.svg' : './icon/chevron-down.svg'" [svgStyle]="{
                            width: '16px',
                            height: '16px'            
                          }"></svg-icon>
                    </div>

                    <div class="ps-4 flex-grow-1" (click)="sortTable('devices')">
                        <strong>{{'NAVIGATION.DEVICES' | translate}}</strong>
                        <svg-icon [src]="sortOrder ? './icon/chevron-up.svg' : './icon/chevron-down.svg'" [svgStyle]="{
                            width: '16px',
                            height: '16px'            
                          }"></svg-icon>
                    </div>
                </div>

                <div class="drag-chart" [ngClass]="{'minigraph-bg': this.vibrationsNewModelSelected == undefined}">
                    <div *ngFor="let record of allRecords; index as j;" class="border border-2 m-3 p-3 rounded-2">
                        <div class="d-flex  cursor-pointer">
                            <div class=" flex-grow-1" (click)="sortTable('filename')">
                                <svg-icon src="./icon/report.svg"></svg-icon>
                                <strong class="colored-title"> {{record?.recordMetadata.fileName}}</strong>
                            </div>
                            <div class="flex-grow-1" (click)="sortTable('date')">
                                <span>{{record?.recordMetadata.timestamp | date: 'dd/MM/yyyy':'UTC'}}</span> <br>
                                <span>{{record?.recordMetadata.timestamp | date: 'HH:mm:ss':'UTC'}}</span>
                            </div>
                            <div class="flex-grow-1" (click)="sortTable('note')">

                                <span> {{record?.recordMetadata.note1}}</span>
                            </div>
                            <div class="flex-grow-1" (click)="sortTable('Maximum')">
                                <div class="container">
                                    <div class="row">
                                        <div *ngFor="let data of record?.signalDataEntity?.signalData?.channels; let i = index"
                                            class="col">
                                            <div>
                                                <span class="text-muted">C{{i + 1}}</span> <br>
                                                {{findMaxAbsValue(data.timeSpectrum.ppvMin, data.timeSpectrum.ppvMax) |
                                                number : '1.2-2'}}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="ps-4 flex-grow-1" (click)="sortTable('devices')">
                                <svg-icon src="./icon/device.svg"></svg-icon>
                                <span class="ps-1">{{record?.recordMetadata.seismographSerialNumber}}</span>
                            </div>
                        </div>
                        <hr>

                        <div class="charts">
                            <div *ngFor="let a of record?.signalDataEntity?.signalData?.channels; index as i;">
                                <canvas class="canvas-custom-width" attr.id="canvas-{{j}}-{{i}}" height="41vh"
                                    width="245%"></canvas>
                            </div>
                        </div>
                        <mat-progress-bar *ngIf="showProgressbar" mode="indeterminate"></mat-progress-bar>
                    </div>
                </div>
            </div>
        </div>


        <div class="m-4 drag-drop-area d-flex justify-content-center" (drop)="onFileDrop($event)"
            (dragover)="onDragOver($event)">
            <div class="text-center">
                <input type="file" id="fileInput" class="file-input" multiple (change)="onFileInputChange($event)"
                    #fileInput>
                <label for="fileInput" class="custom-file-label colored-title p-2">{{'MESSAGE_INFO.UPLOAD_RECORD' |
                    translate}}</label>
                <p>{{'MESSAGE_INFO.ACCEPTED_FILE_FORMATS' | translate}}: sis, csv (Up to 5Mo).</p>
            </div>
        </div>

        <div class="button-group p-3">
            <button class="secondary-button popup-secondary-button" (click)="closeDialog()">{{'BUTTONS.CANCEL' | translate}}</button>
            <button class="primary-button popup-primary-button" (click)="confirm()">{{'BUTTONS.CONFIRM' | translate}}</button>
        </div>
    </div>